import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import MaterialTable from "material-table";
import React from "react";

export default function ProductTable(props: any) {
  const history = useNavigate();
  const columns = [
    { field: "id", title: "ID" },

    { field: "number", title: "number" },
    { field: "name", title: "name", width: 130 },
    {
      field: "description",
      title: "Description",
      width: 130,
    },
    {
      field: "status",
      title: "status",
      width: 130,
    },
    {
      field: "item_image",
      title: "Item image",
      render: (rows) => (
        <img
          src={rows.item_image}
          style={{ width: 50, borderRadius: "10%" }}
          alt="none"
        />
      ),
    },
  ];

  console.log(props);
  const rows = props.props.map((row) => ({ ...row }));

  let keys = Object.keys(props.props);
  console.log(keys);

  return (
    <div style={{ height: 800, width: "100%" }}>
      <MaterialTable
        title="Items"
        data={rows}
        columns={columns}
        actions={[
          {
            icon: "save",
            tooltip: "Save User",
            onClick: (event, rowData) =>
              history(
                "/department/production-dashboard/item-list/item/" +
                  rowData.slug
              ),
          },
        ]}
        components={{
          Action: (props) => (
            <Button
              onClick={(event) => props.action.onClick(event, props.data)}
              color="primary"
              variant="contained"
              style={{ textTransform: "none" }}
              size="small"
            >
              Open
            </Button>
          ),
        }}
      />
    </div>
  );
}
